import React from "react";

// Visually-hidden honeypot input. Bots that auto-fill common label names like
// "Company website" often trip this while real users don't see it.
const Honeypot = ({ value, onChange, name = "_hp" }) => (
  <div
    aria-hidden="true"
    style={{
      position: "absolute",
      left: "-10000px",
      top: "auto",
      width: "1px",
      height: "1px",
      overflow: "hidden",
    }}
  >
    <label htmlFor={name}>Company website</label>
    <input
      id={name}
      name={name}
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={onChange}
      data-testid={`honeypot-${name}`}
    />
  </div>
);

export default Honeypot;
